<template>
  <div v-if="reportBuilt">
    <div class="vx-row">
      <div
        v-for="(vehicle, index) in vehicles"
        :key="index"
        :class="getCardWidthClass()"
      >
        <vx-card :class="getCardBorderClass(vehicle.type)">
          <font-awesome-icon :icon="vehicle.icon" size="2xl" />
          <div class="summary-title">{{ vehicle.title }}</div>
          <div class="h5" v-if="shouldDisplayDonutChart()">
            {{ chartSeries[0].data[index] || 0 }}
          </div>
          <div class="h5" v-else>
            In: {{ calculateTotal(vehicle.type).inCount }} Out:
            {{ calculateTotal(vehicle.type).outCount }}
          </div>
        </vx-card>
      </div>
      <div :class="getTotalCountingWidthClass()">
        <vx-card class="border-left-yellow">
          <div class="summary-title large">Total Counting</div>
          <div class="h5" v-if="shouldDisplayDonutChart()">
            {{ totalDatas }}
          </div>
          <div class="h5" v-else>
            In: {{ totalInData }} Out: {{ totalOutData }}
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["chartSeries", "site", "reportBuilt"],
  data() {
    return {
      // siteId: this.site,
    };
  },
  computed: {
    vehicles() {
      return [
        { 
          type: "Car", 
          icon: "fa-solid fa-car", 
          title: "Car" 
        },
        {
          type: "Motorcycle",
          icon: "fa-solid fa-motorcycle",
          title: "Motorcycle",
        },
        {
          type: "Other Vehicle",
          icon: "fa-solid fa-truck",
          title: "Other Vehicle",
        },
        { 
          type: "Person", 
          icon: "fa-solid fa-person", 
          title: "Person" 
        },
      ];
    },

    //This totaldatas code filtering the code for site 36 (Person In and Person Out)
    // totalDatas() {
    //   var sum = this.chartSeries[0].data.reduce((accumulator, currentValue) => {
    //     return accumulator + currentValue;
    //   }, 0);
    //   return sum;
    // },
    
    totalDatas() {
      var sum = 0;
      sum = this.chartSeries[0].data.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0);
      return sum;
    },

    //This totalindata code filtering the code for site 36 (Person In and Person Out)
    // totalInData() {
    //   return this.chartSeries.reduce(
    //     (total, category) =>
    //       category.name.includes("In") ? total + category.data[1] : total,
    //     0
    //   );
    // },
    // totalOutData() {
    //   return this.chartSeries.reduce(
    //     (total, category) =>
    //       category.name.includes("Out") ? total + category.data[1] : total,
    //     0
    //   );
    // },
    // totalInData() {
    //   if (this.site === 36) {
    //     return this.chartSeries.reduce((total, category) => {
    //       if (category.name.includes("In") && category.name !== "Person In") {
    //         return total + category.data[1];
    //       }
    //       return total;
    //     }, 0);
    //   } else {
    //     return this.chartSeries.reduce(
    //       (total, category) =>
    //         category.name.includes("In") ? total + category.data[1] : total,
    //       0
    //     );
    //   }
    // },
    // totalOutData() {
    //   if (this.site === 36) {
    //     return this.chartSeries.reduce((total, category) => {
    //       if (category.name.includes("Out") && category.name !== "Person Out") {
    //         return total + category.data[1];
    //       }
    //       return total;
    //     }, 0);
    //   } else {
    //     return this.chartSeries.reduce(
    //       (total, category) =>
    //         category.name.includes("Out") ? total + category.data[1] : total,
    //       0
    //     );
    //   }
    // },
    
    totalInData() {
      let total = 0;
      this.chartSeries.forEach((category) => {
          if (category.name.includes("In")) {
            const lastNonZeroIndex = category.data.lastIndexOf(
              category.data.find((value) => value !== 0)
            );
            if (lastNonZeroIndex !== -1) {
              total += category.data
                .slice(lastNonZeroIndex)
                .reduce((acc, value) => acc + value, 0);
            }
          }
        });
      return total;
    },
    totalOutData() {
      let total = 0;
      this.chartSeries.forEach((category) => {
          if (category.name.includes("Out")) {
            const lastNonZeroIndex = category.data.lastIndexOf(
              category.data.find((value) => value !== 0)
            );
            if (lastNonZeroIndex !== -1) {
              total += category.data
                .slice(lastNonZeroIndex)
                .reduce((acc, value) => acc + value, 0);
            }
          }
        });
      return total;
    },
  },
  methods: {
    getTotalCountingWidthClass() {
      return `${this.getCardWidthClass()} mb-5`;
    },
    // shouldDisplayDonutChart() {
    //   console.log("site:", this.site);
    //   return this.chartSeries[0].name.includes("Data Donut");
    // },
    shouldDisplayDonutChart() {
      console.log("site:", this.site);
      if (this.chartSeries.length > 0 && this.chartSeries[0].name) {
        return this.chartSeries[0].name.includes("Data Donut");
      }
      return false;
    },
    // calculateTotal(category) {
    //   const inData = this.chartSeries.find(
    //     (item) => item.name === `${category} In`
    //   );
    //   const outData = this.chartSeries.find(
    //     (item) => item.name === `${category} Out`
    //   );
    //   const inCount = inData ? inData.data[1] : 0;
    //   const outCount = outData ? outData.data[1] : 0;
    //   return { inCount, outCount };
    // },
    calculateTotal(category) {
      const inData = this.chartSeries.find(
        (item) => item.name === `${category} In`
      );
      const outData = this.chartSeries.find(
        (item) => item.name === `${category} Out`
      );

      let inCount = 0;
      let outCount = 0;

      // Find the index of the last non-zero value in the data array
      let lastNonZeroIndexIn = inData
        ? inData.data.lastIndexOf(inData.data.find((value) => value !== 0))
        : -1;
      let lastNonZeroIndexOut = outData
        ? outData.data.lastIndexOf(outData.data.find((value) => value !== 0))
        : -1;

      // Sum only from the last non-zero value onwards
      if (lastNonZeroIndexIn !== -1) {
        inCount = inData.data
          .slice(lastNonZeroIndexIn)
          .reduce((total, value) => total + value, 0);
      }

      if (lastNonZeroIndexOut !== -1) {
        outCount = outData.data
          .slice(lastNonZeroIndexOut)
          .reduce((total, value) => total + value, 0);
      }

      return { inCount, outCount };
    },

    getCardWidthClass() {
      const totalVisibleCards = this.vehicles.length + 1;
      switch (totalVisibleCards) {
        case 1:
          return "vx-col w-full";
        case 2:
          return "vx-col w-full sm:w-1/2";
        case 3:
          return "vx-col w-full sm:w-1/2 lg:w-1/3";
        case 4:
          return "vx-col w-full sm:w-1/2 lg:w-1/4";
        default:
          return "vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5";
      }
    },
    getCardBorderClass(type) {
      switch (type) {
        case "Car":
          return "border-left-blue";
        case "Motorcycle":
          return "border-left-red";
        case "Other Vehicle":
          return "border-left-grey";
        case "Person":
          return "border-left-green";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.border-left-blue {
  border-left: 4px solid #4e73df;
}

.border-left-blue svg path {
  fill: #4e73df;
}

.border-left-red {
  border-left: 4px solid #e74a3a;
}

.border-left-red svg path {
  fill: #e74a3a;
}

.border-left-grey {
  border-left: 4px solid #848796;
}

.border-left-grey svg path {
  fill: #848796;
}

.border-left-green {
  border-left: 4px solid #1bc88a;
}

.border-left-green svg path {
  fill: #1bc88a;
}

.border-left-yellow {
  border-left: 4px solid #f7c446;
}

.summary-title {
  font-weight: 600;
  font-size: 12px;
  padding: 4px 0;
  text-transform: uppercase;
}

.total-text {
  font-size: 23px;
}

.summary-title.large {
  font-size: 14px;
  margin-top: 25px;
}
</style>
